import questions from "@views/questions/index";

const questionsRouter = [
  {
    path: "questions",
    name: "questions",
    // component: physicalStores,
    component: (resolve) => require(["@views/questions/index"], resolve),
    meta: {
      title: "店面搜索",
      belong: "questions",
    },
  },
  {
    path: "welcome",
    name: "welcome",
    component: (resolve) => require(["@views/questions/welcome"], resolve),
    meta: {
      title: "欢迎页",
      belong: "questions",
    },
  },
  {
    path: "questionLogin",
    name: "questionLogin",
    component: (resolve) =>
      require(["@views/questions/questionLogin"], resolve),
    meta: {
      title: "登录",
      belong: "questions",
    },
  },
  {
    path: "questionReg",
    name: "questionReg",
    component: (resolve) => require(["@views/questions/questionReg"], resolve),
    meta: {
      title: "注册",
      belong: "questions",
    },
  },
  {
    path: "forgetPwd",
    name: "forgetPwd",
    component: (resolve) => require(["@views/questions/forgetPwd"], resolve),
    meta: {
      title: "忘记密码",
      belong: "questions",
    },
  },
  {
    path: "direction",
    name: "direction",
    component: (resolve) => require(["@views/questions/direction"], resolve),
    meta: {
      title: "使用说明",
      isQuestionLogin: true,
      requireAuth: true,
      belong: "questions",
    },
  },
  {
    path: "wxLogin",
    name: "wxLogin",
    component: (resolve) => require(["@views/questions/wxLogin"], resolve),
    meta: {
      title: "微信登录",
      belong: "questions",
    },
  },
  {
    path: "projectList",
    name: "projectList",
    component: (resolve) => require(["@views/questions/projectList"], resolve),
    meta: {
      title: "工程列表",
      keepAlive: true,
    },
  },
  {
    path: "pulishComment",
    name: "pulishComment",
    component: (resolve) =>
      require(["@views/questions/pulishComment"], resolve),
    meta: {
      title: "评价",
    },
  },
  {
    path: "400-cmt",
    name: "400-cmt",
    component: (resolve) => require(["@views/questions/400-Comment"], resolve),
    meta: {
      title: "评价",
    },
  },
];

export default questionsRouter;



// WEBPACK FOOTER //
// ./src/router/questions/index.js